import { Texture } from "@pixi/core"
import { AudioManager } from "../../../../audio/AudioManager";
import { AudioNames } from "../../../../audio/AudioNames";
import { IDestroyOptions } from "@pixi/display";
import { Button } from "ui-pixijs";

export class UiButton extends Button {
    public constructor(
        uiTexture: Texture,
        protected readonly audioManager: AudioManager
    ) {
        super();
        this.defaultView.texture = uiTexture;
        this.onUp.add(this.handleUp, this);
    }

    protected handleUp(): void {
        this.audioManager.play(AudioNames.Click);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.onUp.remove(this.handleUp, this);
        super.destroy(options);
    }
}